export const ACTIVITY_LEVEL = "Activity Level";
export const ACTIVITY_LEVEL_AT_WORK = "Activity Level at Work";
export const COOKING_BUDGET = "Cooking Budget";
export const COOKING_TIME = "Cooking Time";
export const DIETARY_PREFERENCES = "Dietary Preferences";
export const INJURIES = "Injuries";
export const TRAINING_SCHEDULE = "Training Schedule";
export const TRAINING_EXPERIENCE = "Training Experience";
export const TRAINING_LOCATION = "Training Location";
export const TRAINING_EQUIPMENT = "Training Equipment";
export const ALLERGIES = "Allergies";

